<template>
	<section class="page-reset-send">
		<PageHeader title="Reset password" />
		<SendResetForm />
	</section>
</template>

<script>
import SendResetForm from "./SendResetForm";
import PageHeader from "../shared/PageHeader";

export default {
	name: "SendReset",
	components: {
		SendResetForm,
		PageHeader
	},
};
</script>